import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axiosInstance from '../utils/axiosConfig';
import { getApiError } from '../utils/apiError';
import { Modal } from './common';

function UnassignAssetModal({ asset, onClose, onUnassign }) {
  const [saving, setSaving] = useState(false);
  const [motivo, setMotivo] = useState('');

  const handleUnassign = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const response = await axiosInstance.post(`/api/activos/${asset.id}/desasignar`, {
        motivo: motivo.trim()
      });

      if (response.data.message) {
        onUnassign();
        onClose();

        if (typeof window.refreshEmployeeData === 'function') {
          window.refreshEmployeeData();
        }
      } else {
        throw new Error('No se recibió confirmación del servidor');
      }
    } catch (error) {
      console.error('Error al desasignar:', error);
      alert(error.response
        ? getApiError(error, 'Error al desasignar el equipo')
        : (error.message || 'Error al desasignar el equipo'));
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={!!asset} onClose={onClose} size="sm">
      <Modal.Header onClose={onClose}>Desasignar Equipo</Modal.Header>
      <Modal.Body>
        <p><strong>Equipo:</strong> {asset?.tipo} - {asset?.nombre_equipo}</p>
        <p><strong>Asignado a:</strong> {asset?.empleado}</p>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-4 text-amber-800 text-sm">
          ¿Está seguro que desea desasignar este equipo?
        </div>
        <div className="mt-4">
          <label htmlFor="motivo-desasignar-equipo" className="block text-sm font-medium text-gray-700 mb-1">
            Motivo (opcional)
          </label>
          <textarea
            id="motivo-desasignar-equipo"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            rows={2}
            placeholder="Por qué se retira el equipo"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg resize-y focus:ring-2 focus:ring-sura-blue focus:border-transparent"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose} disabled={saving}>
          Cancelar
        </button>
        <button className="btn btn-primary" onClick={handleUnassign} disabled={saving}>
          {saving ? 'Desasignando...' : 'Desasignar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

UnassignAssetModal.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.number.isRequired,
    tipo: PropTypes.string.isRequired,
    nombre_equipo: PropTypes.string.isRequired,
    empleado: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onUnassign: PropTypes.func.isRequired,
};

export default UnassignAssetModal;